import { render, staticRenderFns } from "./SurveyPlanFormHeader.vue?vue&type=template&id=0d2fe8da&scoped=true&"
import script from "./SurveyPlanFormHeader.vue?vue&type=script&lang=ts&"
export * from "./SurveyPlanFormHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyPlanFormHeader.vue?vue&type=style&index=0&id=0d2fe8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2fe8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
